module.exports = "<p>\n  client-agents-list works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/client-agents-list/client-agents-list.component.html
// module id = ./src/app/components/client-agents-list/client-agents-list.component.html
// module chunks = main